import EmailAdditionalInventory from './EmailAdditionalInventory';
export default EmailAdditionalInventory;